import { render } from "./FieldActionEditor.vue?vue&type=template&id=21ff8ecf"
import script from "./FieldActionEditor.vue?vue&type=script&lang=js"
export * from "./FieldActionEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__